import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Collapse, SvgIcon, SvgIconProps } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { createStyles, withStyles } from "@mui/styles";
import { TreeItem, TreeItemProps } from "@mui/x-tree-view";
import React from "react";
import { animated, useSpring } from "react-spring"; // web.cjs is required for IE 11 support

export const CollapseIcon = (props: SvgIconProps) => {
  return <KeyboardArrowUpIcon {...props} sx={{ fontSize: 16 }} />;
};

export const ExpandIcon = (props: SvgIconProps) => {
  return <KeyboardArrowDownIcon {...props} sx={{ fontSize: 16 }} />;
};

export const LeafIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" sx={{ fontSize: 16 }}>
      <path d="M7.99984 11.3334C9.84079 11.3334 11.3332 9.84097 11.3332 8.00002C11.3332 6.15907 9.84079 4.66669 7.99984 4.66669C6.15889 4.66669 4.6665 6.15907 4.6665 8.00002C4.6665 9.84097 6.15889 11.3334 7.99984 11.3334Z" fill="currentColor" />
    </SvgIcon>
  );
};

function TransitionComponent(props: TransitionProps) {
  const style = useSpring({
    from: { opacity: 0, transform: "translate3d(20px,0,0)" },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

const StyledTreeItem = withStyles(() =>
  createStyles({
    iconContainer: {},
    group: {
      marginLeft: 12,
      paddingLeft: 12,
    },
  })
)((props: TreeItemProps) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

export default StyledTreeItem;
